<canvas
    baseChart
    [options]="chartOptions"
    [data]="chartData"
    [type]="$any(pieChartType)"
></canvas>
